import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useRef } from "react";
import {
  cardsContainerSx,
  cardsGradientOverlaySx,
  sectionContainerSx,
  sectionHeaderSx,
  stickyBackgroundSx,
  stickyFadeOverlaySx,
  videoBackgroundSx,
  videoOverlaySx,
} from "./PlatformFeaturesSection.sx";
import { cardsData, sectionTitle } from "./PlatformFeaturesSection.config";
import { PlatformFeatureCard } from "./PlatformFeatureCard";
import { useCardsOpacityAnimation } from "./useCardsOpacityAnimation";
import featuresVideo from "../../assets/BackgroundMovies/features_movie_1920x1080.mp4";

export const PlatformFeaturesSection = () => {
  const cardsContainerRef = useRef<HTMLDivElement>(null);

  useCardsOpacityAnimation(cardsContainerRef);

  return (
    <Box
      component="section"
      id="platform-features"
      sx={sectionContainerSx}
    >
      {/* Section Header - above video */}
      <Box sx={sectionHeaderSx}>
        <Typography variant="h2" component="h2">
          {sectionTitle}
        </Typography>
      </Box>

      {/* Sticky background with video */}
      <Box sx={stickyBackgroundSx}>
        <Box sx={videoBackgroundSx}>
          <video autoPlay muted loop playsInline>
            <source src={featuresVideo} type="video/mp4" />
          </video>
        </Box>
        <Box sx={videoOverlaySx} />
        {/* Fade overlay for cards - top and bottom gradient */}
        <Box sx={stickyFadeOverlaySx} />
      </Box>

      {/* Cards layer - scrolls naturally over the sticky background */}
      <Box sx={cardsGradientOverlaySx}>
        <Stack ref={cardsContainerRef} sx={cardsContainerSx}>
          {cardsData.map((card, i) => (
            <PlatformFeatureCard key={card.id} card={card} index={i} />
          ))}
        </Stack>
      </Box>
    </Box>
  );
};

export default PlatformFeaturesSection;
